var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243:13501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20808 5.27727C-0.220093 8.70544 -0.220094 14.265 3.20808 17.6932C4.42208 18.9072 5.90509 19.6866 7.46397 20.0453L7.46398 18.0312C6.41552 17.7139 5.41535 17.1414 4.58762 16.3136C1.9251 13.6511 1.9251 9.31934 4.58762 6.65682C7.25015 3.9943 11.5819 3.9943 14.2444 6.65682L14.3617 6.77408L12.1751 6.78098L12.1751 8.72614L17.6933 8.72614L17.6933 3.20796L15.7412 3.20106L15.7412 5.39454L15.624 5.27727C12.1958 1.8491 6.63625 1.8491 3.20808 5.27727ZM9.41603 11.4852L9.41603 19.7625L17.6933 19.7625L17.6933 11.4852L9.41603 11.4852ZM11.3681 17.8104L11.3681 13.4373L15.7412 13.4373L15.7412 17.8104L11.3681 17.8104Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243:13501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate_right.7bdaa1e3c10f7448fe0f302fcace0fcb.svg";
export { ForwardRef as ReactComponent };